var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 329"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Shadow",
    opacity: 0.5,
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    fill: "#E7EDFC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.2327 2.2998C20.5399 2.2998 19.166 3.67367 19.166 5.36647C19.166 7.05927 20.5399 8.43314 22.2327 8.43314C23.9255 8.43314 25.2993 7.05927 25.2993 5.36647C25.2993 3.67367 23.9255 2.2998 22.2327 2.2998ZM21.4016 6.68207L20.3007 5.58114C20.1811 5.46154 20.1811 5.26834 20.3007 5.14874C20.4203 5.02914 20.6135 5.02914 20.7331 5.14874L21.6193 6.03194L23.7292 3.92207C23.8488 3.80247 24.042 3.80247 24.1616 3.92207C24.2812 4.04167 24.2812 4.23487 24.1616 4.35447L21.834 6.68207C21.7175 6.80167 21.5212 6.80167 21.4016 6.68207Z",
    fill: "#05CD99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "iconMic",
    d: "M11.8827 13.396C12.8826 13.396 13.6838 12.5849 13.6838 11.5802L13.6898 7.9486C13.6898 6.94387 12.8826 6.13281 11.8827 6.13281C10.8827 6.13281 10.0755 6.94387 10.0755 7.9486V11.5802C10.0755 12.5849 10.8827 13.396 11.8827 13.396ZM15.0753 11.5802C15.0753 13.396 13.5453 14.667 11.8827 14.667C10.2201 14.667 8.69006 13.396 8.69006 11.5802H7.66602C7.66602 13.6441 9.30449 15.351 11.2803 15.6475V17.6328H12.4851V15.6475C14.4609 15.357 16.0993 13.6502 16.0993 11.5802H15.0753Z",
    fill: "#83B8BF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMic);
export default __webpack_public_path__ + "static/media/iconMic.422685070fdbbe14c7003f19c59fe0cb.svg";
export { ForwardRef as ReactComponent };